<template>
  <qx-card title="列表">
    <OrderMatchDialog ref="orderMatchDialog" @sub="getData"></OrderMatchDialog>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ImportBtn
          title="大宗订单导入"
          bizCodes="imp1000133"
          type="getImportTempFile"
          :fileUrl="false"
          :downloadTipsShow="false"
          btnName="磅单信息文件导入"
      />
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <ImportBtn
            title="大宗订单导入"
            bizCodes="imp1000134"
            type="getImportTempFile"
            :fileUrl="false"
            :downloadTipsShow="false"
            btnName="磅单维护文件导入"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="dZOrderBO.ajax?cmd=getOrderList"
            :params="fullSearchData"
            bizName="大宗订单数据导出"
            bizCode="exp10010501"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!--          <el-table-column type="selection" width="55" :selectable="judgeSelect"/>-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
                :fixed="item.fixed"
                align="center"
                v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 订单状态 -->
                <section v-else-if="scope.column.property === 'state'">
                  {{scope.row[scope.column.property] === 1 ? '运输完成' : '运输中' }}
                </section>
                <!-- 订单状态 end -->
                <!-- 线路名称 -->
                <section
                    v-else-if="scope.column.property === 'lineName'"
                >
                  <span
                      :class="{
                      primary: scope.row.lineId !== -1 && scope.row.lineId !==null,
                      cur: scope.row.lineId !== -1 && scope.row.lineId !==null,
                    }"
                      @click="toLineDetail(scope.row)"
                  >{{
                      scope.row[scope.column.property]
                    }}
                  </span>
                </section>
                <!-- 线路名称 end -->
                <!-- 车牌号码 -->
                <section
                    v-else-if="scope.column.property === 'plateNumber'"
                    @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 车牌号码 end-->
                <!-- 司机姓名 -->
                <section
                    v-else-if="scope.column.property === 'driverName'"
                    @click="toDriverDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 司机姓名 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="170"
              fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isShowDropdown="true"
                  :isCenter="true"
                  :btnList="[
                  {
                    permpisions: '',
                    showCondition: true,
                    name: '修改',
                    event: () => toOrderDetail(scope.row, 'edit'),
                  },
                   {
                    permpisions: '',
                    showCondition: scope.row['orderSource'] !== 'PC导入,司机',
                    name: '订单匹配',
                    event: () => showOrderMatchDialog(scope.row),
                  },

                ]"
              />
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import OrderMatchDialog from './orderMatchDialog/orderMatchDialog';
import {
  dZOrderList,
} from 'api/operate';

export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ImportBtn,
    ExportBtn,
    TableBtn,
    TableSetting, // 表格设置
    OrderMatchDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'orderId', label: '订单号', fixed: true},
          {prop: 'state', label: '订单状态'},
          {prop: 'dataStateStr', label: '数据状态'},
          {prop: 'orderSource', label: '数据来源'},
          {prop: 'customerName', label: '客户名称'},
          {prop: 'customerNumber', label: '客户单号'},
          {prop: 'productName', label: '货品名称'},
          {prop: 'lineName', label: '线路名称'},
          {prop: 'driverName', label: '司机名称'},
          {prop: 'driverPhone', label: '司机账号'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'weightNumber', label: '装货磅单号'},
          {prop: 'loadingTime', label: '装货时间'},
          {prop: 'netWeightDouble', label: '装货净重'},
          {prop: 'unloadNumber', label: '卸货磅单号'},
          {prop: 'unloadTime', label: '卸货时间'},
          {prop: 'unloadNetWeightDouble', label: '卸货净重'},
          {prop: 'settlementUnitPriceDouble', label: '结算单价'},
          {prop: 'goodsUnitPriceDouble', label: '拉运货值'},
          {prop: 'deductions', label: '扣损金额'},
          {prop: 'settlementPrice', label: '结算金额'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: dZOrderList,
    toOrderDetail (item, isEdit) {
      this.jump({
        label: isEdit ? `修改订单-${item.orderId}` : `订单详情-${item.orderId}`,
        url: `/manage/operate/dzOrder/dzOrderlist/detail?orderId=${item.orderId}&type=${isEdit}`,
        full: true,
      });
    },
    toLineDetail (item, type = '') {
      if (item.lineId === -1 || item.lineId === null) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.lineId}&type=${type}`,
        full: true,
      });
    },
    toCarDetail (item) {
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleId}&vehicleClass=${item.vehicleClass}&type=${type}`,
        full: true,
      });
    },
    toDriverDetail (item, type = '') {
      this.jump({
        label: type ? '审核司机' : '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${item.driverId}&type=${type}`,
        full: true,
      });
    },
    showOrderMatchDialog (item) { // 订单匹配
      this.$refs.orderMatchDialog.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
